import acierto1 from "../assets/bg/acierto-avatar-1.png";
import acierto2 from "../assets/bg/acierto-avatar-2.png";
import acierto3 from "../assets/bg/acierto-avatar-3.png";
import acierto4 from "../assets/bg/acierto-avatar-4.png";

import error1 from "../assets/bg/error-avatar-1.png";
import error2 from "../assets/bg/error-avatar-2.png";
import error3 from "../assets/bg/error-avatar-3.png";
import error4 from "../assets/bg/error-avatar-4.png";

const ACIERTO_AVATARS = [acierto1, acierto2, acierto3, acierto4];
const ERROR_AVATARS = [error1, error2, error3, error4];

/** URL (bundler) de un avatar de respuesta correcta, al azar. Llamar al abrir cada modal. */
export function getRandomAciertoAvatar() {
	return ACIERTO_AVATARS[Math.floor(Math.random() * ACIERTO_AVATARS.length)];
}

/** URL (bundler) de un avatar de respuesta incorrecta, al azar. Llamar al abrir cada modal. */
export function getRandomErrorAvatar() {
	return ERROR_AVATARS[Math.floor(Math.random() * ERROR_AVATARS.length)];
}
